import { useFormik } from 'formik';
import { capitalize, startCase, camelCase } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2';
import configObject from '../../../../config';
import Autocomplete from 'react-google-autocomplete';

const validationSchema = Yup.object({
  category: Yup.string().required('Please select category'),
  single_item_title: Yup.string().required('Please enter item name'),
  destination: Yup.string().required('Please enter destination'),
  port_of_discharge: Yup.string().required('Please select port of discharge'),
  email: Yup.string()
    .email('Please enter valid email')
    .required('Please enter email'),
  phone: Yup.string(),
});

const TransportServiceTab = ({ onSubmit }) => {
  const serviceData = useSelector((state) => state.enumData);

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    resetForm,
    isValid,
    dirty,
    setFieldValue,
  } = useFormik({
    initialValues: {
      category: '',
      single_item_title: '',
      destination: '',
      port_of_discharge: '',
      email: '',
      phone: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Set job_type to 'transport' for transport service
      values.job_type = 'transport';
      onSubmit(values, resetForm);
    },
  });

  return (
    <form onSubmit={handleSubmit} id="service-form">
      <Row>
        <Col md={6} lg={3} className="mt">
          <label style={{ marginBottom: '0px' }}>Select Category</label>
          <select
            name="category"
            className="form-control"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.category}
          >
            {Object.keys(serviceData.job.category)
              .filter((key) => key != 1)
              .map((key) => (
                <option value={key} key={key}>
                  {capitalize(serviceData.job.category[key])}
                </option>
              ))}
          </select>
          <span className="text-danger">{touched.category && errors.category}</span>
        </Col>
        <Col md={6} lg={3} className="mt">
          <label style={{ marginBottom: '0px' }}>Item Name {'(Separated by commas) '}</label>
          <input
            name="single_item_title"
            type="text"
            className="form-control"
            placeholder="item 1, item 2"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.single_item_title}
          />
          <span className="text-danger">{touched.single_item_title && errors.single_item_title}</span>
        </Col>
        <Col md={6} lg={3} className="mt">
          <label style={{ marginBottom: '0px' }} htmlFor="port_of_discharge">Port of Discharge</label>
          <select
            name="port_of_discharge"
            id="port_of_discharge"
            type="text"
            className="form-control"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.port_of_discharge}
          >
            <option value="">Select Port</option>
            {serviceData?.ports?.length > 0 &&
              serviceData?.ports.map((obj) => (
                <option value={obj.uuid} key={obj.uuid}>
                  {/* Rendered as stored: startCase(camelCase()) turned "Ogun II"
                      into "Ogun Ii", "Abuja (FCT)" into "Abuja Fct" and
                      "PTML" into "Ptml". */}
                  {obj.port_of_operation}
                </option>
              ))}
          </select>
          <span className="text-danger">
            {touched.port_of_discharge && errors.port_of_discharge}
          </span>
        </Col>

        <Col md={6} lg={3} className="mt">
          <label style={{ marginBottom: '0px' }} htmlFor="destination">Destination</label>
          <Autocomplete
            name="destination"
            id="destination"
            placeholder="Full Address"
            value={values.destination}
            options={{
              types: [],
              componentRestrictions: {
                country: 'ng',
              },
            }}
            onChange={handleChange}
            onBlur={handleBlur}
            apiKey={configObject.GOOGLE_API_KEY}
            onPlaceSelected={(place) => {
              setFieldValue('destination', place.formatted_address);
            }}
            className={`form-control ${
              touched.destination && errors.destination ? 'is-invalid' : ''
            }`}
            style={{
              height: '50px',
            }}
          />
          <span className="text-danger">{touched.destination && errors.destination}</span>
        </Col>

        <Col md={6} lg={4} className="mt position-relative">
          <label htmlFor="email">Email</label>
          <input
            name="email"
            id="email"
            type="email"
            className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            placeholder="Enter your Email"
          />
          <span className="text-danger">{touched.email && errors.email}</span>
        </Col>

        <Col md={6} lg={4} className="mt position-relative">
          <label htmlFor="phone">Phone</label>
          <PhoneInput
            country={'ng'}
            value={values.phone}
            onChange={(x) => setFieldValue('phone', '+' + x)}
            placeholder="Enter your Phone"
            inputStyle={{
              height: '50px',
              width: '100%',
            }}
          />
        </Col>
        <Col md={6} lg={4} className="mt">
          <div className="text-right">
            <button className="post-button w-100" type="submit" disabled={!(isValid && dirty)}>
              Submit
            </button>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default TransportServiceTab;